import '../css/signup.scss'

import $ from 'jquery'
window.$ = window.jQuery = $

import { initGoogleAuth, handleGoogleResponse } from './_partials/sign-in/_googleSignIn'
import { initMicrosoftAuth } from './_partials/sign-in/_microsoftSignIn'
import sendSignInUserData from './_partials/sign-in/_sendFormData'
import createEnvironment from './_partials/sign-in/_enviromentCreation'
import initProductTour from './_partials/sign-in/_productTour'
// import customSelect from './_partials/sign-in/_customSelect'
import checkDomain from './_partials/sign-in/_check-domain-field'
// import getUserEmail from './_partials/sign-in/_getUserEmailAddress'
import formDataValidation from './_partials/sign-in/_formDataValidation'
import formRefill from './_partials/sign-in/_formRefill'
import passwordToggler from './_partials/sign-in/_passwordToggler'
import reframe from './_partials/reframe'
import fixScreenHeight from './_partials/sign-in/_fixScreenHeight'
import { KVKSearch } from './_partials/forms/KVKCheck'
import slimSelect from './_partials/_slim-select'
import validate from './_partials/_validate'
// import { toggleVisibility } from './_partials/redesign/forms/toggleVisibility'

window.handleResponse = (response) => {
    handleGoogleResponse(response)
}

window.addEventListener('DOMContentLoaded', () => {
    slimSelect()
    formRefill()
    reframe()
    fixScreenHeight()
    KVKSearch('[name="company_name"]')
    if (document.getElementById('user-step-1')) {
        validate('#user-step-1')
        KVKSearch('[name="company_name"]', 'select[name="branch"]', 'select[name="team_size"]')
        initGoogleAuth()
        initMicrosoftAuth()
        formDataValidation('#user-step-1')
        sendSignInUserData('user-step-1', 'signup/domain_request/')

        // Allow only digits, spaces and + in phone field
        const phoneInput = document.querySelector('#user-step-1 [name="phone"]')
        if (phoneInput) {
            phoneInput.addEventListener('input', (e) => {
                e.target.value = e.target.value.replace(/[^\d +]/g, '')
            })
        }
    } else if (document.getElementById('user-step-2')) {
        checkDomain('#user-step-2')
        passwordToggler()
        formDataValidation('#user-step-2')
        sendSignInUserData('user-step-2', 'signup/domain_request/finish/', 'PUT')
    } else if (document.getElementById('user-step-3')) {
      // initProductTour() sets window.simplicateEnvironmentReady, so it must run
      // before createEnvironment() starts polling for readiness.
      initProductTour()
      createEnvironment()
    }

    $('.authorization__steps-label a').on('click', function (e) {
      if (window.history.length > 1) {
        e.preventDefault()
        window.history.back()
      }
    })

  $('form.authorization__form').on('refill', function() {
    const microsoftId = ($(this).find('[name=microsoft_id]').val() || '').trim()
    const googleId = ($(this).find('[name=google_id]').val() || '').trim()

    if (!microsoftId && !googleId) {
      return
    }

    $('.authorization__social').addClass('hidden')
    $(`.authorization__${microsoftId ? 'microsoft' : 'google'}-connected, .authorization__social-connections`).removeClass('hidden')
  })
})
